import { withoutReviewers } from 'src/data/user';
import { pluralize } from 'src/lib/format';

import { useCurrentCustomer } from '../customer/useCurrentCustomer';

import { useCustomerMembers } from './useCustomerMembers';

const UNLIMITED_MEMBERS_VALUE = -1;

export const useCustomerMaxMembers = () => {
  const currentCustomer = useCurrentCustomer();
  const { members } = useCustomerMembers();
  const usersCount = withoutReviewers(members).length;
  const { maxMembers } = currentCustomer || {};
  const isUsersUnlimited = maxMembers === UNLIMITED_MEMBERS_VALUE;
  const spendAllInvites = !isUsersUnlimited && usersCount >= maxMembers;
  const usersLabel = pluralize(maxMembers, 'user', 'users');
  const textInvites = isUsersUnlimited
    ? `${usersCount} ${usersLabel}`
    : `${usersCount}/${maxMembers} ${usersLabel}`;

  return {
    isUsersUnlimited,
    spendAllInvites,
    usersCount,
    maxMembers,
    textInvites,
  };
};
